import React from 'react';
import {
  CertificationStyleConfig,
  HeaderStyleConfig,
} from '../../../utils/api/pdfLayout';
import { StyleFields } from './SectionStyleControls';
import SectionBodyControls from './SectionBodyControls';

interface Props {
  config: CertificationStyleConfig;
  onChange: (fields: Partial<CertificationStyleConfig>) => void;
}

const HEADER_FIELDS = ['fontStyle', 'fontSize', 'color', 'backgroundColor'];

// SW2-2344: lets the "Specific Site Notes & Information" header match the rest of the form,
// plus the Site Notes box appearance, statement / notes text and block spacing.
const CertificationStyleControls: React.FC<Props> = ({ config, onChange }) => {
  return (
    <div className='ple-section-style'>
      <span className='ple-section-style__label'>Certification</span>
      <div className='ple-section-style__row'>
        <StyleFields
          label='Header'
          fields={HEADER_FIELDS}
          value={config.header_style ?? {}}
          onChange={(header_style: HeaderStyleConfig) => onChange({ header_style })}
        />
      </div>
      <SectionBodyControls
        label='Certification'
        appearance={config.appearance}
        bodyStyle={config.body_style ?? {}}
        paddingTip='The space between the certification blocks.'
        onChange={onChange}
      />
    </div>
  );
};

export default CertificationStyleControls;
